export const accountConstants = {
    LOGIN_LOAD: 'USERS_LOGIN_REQUEST',
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    REGISTER: 'REGISTER',
    LOGOUT: 'USERS_LOGOUT',

    GET_REQUEST: 'GET_REQUEST',
    GET_SUCCESS: 'GET_SUCCESS',
    GET_FAILURE: 'GET_FAILURE',

    RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',

    GET_PROFILE_REQUEST: 'GET_PROFILE_REQUEST',
    GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
    GET_PROFILE_FAILURE: 'GET_PROFILE_FAILURE',

    GET_ALL_REQUEST: 'GET_ALL_REQUEST',
    GET_ALL_SUCCESS: 'GET_ALL_SUCCESS',
    GET_ALL_FAILURE: 'GET_ALL_FAILURE',

    GET_ALL_TYPE_REQUEST: 'GET_ALL_TYPE_REQUEST',
    GET_ALL_TYPE_SUCCESS: 'GET_ALL_TYPE_SUCCESS',
    GET_ALL_TYPE_FAILURE: 'GET_ALL_TYPE_FAILURE',

    GET_BY_CUSTOMER_ALL_REQUEST: 'GET_BY_CUSTOMER_ALL_REQUEST',
    GET_BY_CUSTOMER_ALL_SUCCESS: 'GET_BY_CUSTOMER_ALL_SUCCESS',
    GET_BY_CUSTOMER_ALL_FAILURE: 'GET_BY_CUSTOMER_ALL_FAILURE',

    ADD_INTERIM_ACCOUNT_REQUEST: 'ADD_INTERIM_ACCOUNT_REQUEST',
    ADD_INTERIM_ACCOUNT_SUCCESS: 'ADD_INTERIM_ACCOUNT_SUCCESS',
    ADD_INTERIM_ACCOUNT_FAILURE: 'ADD_INTERIM_ACCOUNT_FAILURE',

    ADD_CUSTOMER_ACCOUNT_REQUEST: 'ADD_CUSTOMER_ACCOUNT_REQUEST',
    ADD_CUSTOMER_ACCOUNT_SUCCESS: 'ADD_CUSTOMER_ACCOUNT_SUCCESS',
    ADD_CUSTOMER_ACCOUNT_FAILURE: 'ADD_CUSTOMER_ACCOUNT_FAILURE',

    UPDATE_PROFILE_REQUEST: 'UPDATE_PROFILE_REQUEST',
    UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
    UPDATE_PROFILE_FAILURE: 'UPDATE_PROFILE_FAILURE',

    UPDATE_REQUEST: 'UPDATE_REQUEST',
    UPDATE_SUCCESS: 'UPDATE_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_FAILURE',

    DELETE_REQUEST: 'DELETE_REQUEST',
    DELETE_SUCCESS: 'DELETE_SUCCESS',
    DELETE_FAILURE: 'DELETE_FAILURE',


};
